import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as rotatingSlides from '@components/sections/features/components/rotating-slides/rotating-slides.js';

gsap.registerPlugin(ScrollTrigger);

const section = document.getElementById('intuitive-interface');
const intro = section.querySelector('.intuitive-interface__intro');
const introLine = section.querySelector('.intuitive-interface__intro__line');
const slides = section.querySelector('.intuitive-interface__rotating-slides');
const canvasWrapper = document.getElementById('rotating-360-wrapper');
const { goToSlide } = rotatingSlides.init(section.querySelector('.rotating-slides'));

const onEnter = () => {
  gsap.timeline()
    .to([intro, slides], {
      y: 0,
      autoAlpha: 1,
      duration: 1.0,
    })
    .to(introLine, {
      scaleY: 1.0,
      duration: 0.5,
    }, '-=0.5');

  gsap.to(canvasWrapper, {
    filter: 'blur(5px)',
    opacity: 0.5,
    duration: 0.3,
  });
};
const onLeave = () => {
  gsap.to([intro, slides], {
    autoAlpha: 0,
    duration: 0.3,
  });
};
const onLeaveBack = () => {
  onLeave();

  gsap.to(canvasWrapper, {
    filter: 'blur(0px)',
    opacity: 1.0,
    duration: 0.3,
  });
};

gsap.set(intro, { autoAlpha: 0, y: '+=100' });
gsap.set(slides, { autoAlpha: 0, y: '+=100' });
gsap.set(introLine, { scaleY: 0 });

// Pin section.
gsap.timeline({
  scrollTrigger: {
    pin: section,
    end: '+=10000',
    scrub: true,
    fastScrollEnd: true,
    onUpdate(self) {
      const { progress } = self;

      if (progress >= 0.85) {
        goToSlide(6);
      } else if (progress >= 0.71) {
        goToSlide(5);
      } else if (progress >= 0.57) {
        goToSlide(4);
      } else if (progress >= 0.42) {
        goToSlide(3);
      } else if (progress >= 0.28) {
        goToSlide(2);
      } else if (progress >= 0.14) {
        goToSlide(1);
      } else if (progress >= 0) {
        goToSlide(0);
      }
    },
  },
});

// Animate section contents.
gsap.timeline({
  scrollTrigger: {
    trigger: section,
    start: 'top top',
    end: '+=9500',
    fastScrollEnd: true,
    scrub: true,
    onEnter,
    onEnterBack: onEnter,
    onLeave,
    onLeaveBack,
  },
});
